import TableToExcel from "@linways/table-to-excel";
export function exportTableToExcel(tableID, filename = '') {
    TableToExcel.convert(document.getElementById(tableID), {
      name: filename
    });
}